<template>
    <v-container>
        <v-row>
            <v-col md="12" cols="12">
                <WarningAlert>
                    {{$t("common.access_denied_age_18")}}
                </WarningAlert>             
            </v-col>
        
        </v-row>
    </v-container>
</template>

<script>
import { VRow, VCol, VContainer } from 'vuetify/lib';
import WarningAlert from '@/components/alert/WarningAlert.vue';

export default {
    components: { VRow, VCol, VContainer, WarningAlert },
    computed: {},
    mounted() {}
};
</script>